import React, { useState } from 'react';
import { Box, Text, Flex, Badge, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter } from '@chakra-ui/react';
import InvoiceDetails from '../global/invoiceDetails'; // Import the InvoiceDetails component

const InvoiceCard = ({ invoice }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);


  const formatJobStartDate = (invoice) => {
    const date = new Date(invoice.jobStartedFrom);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const formatJobEndDate = (invoice) => {
    const date = new Date(invoice.jobEndedOn);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const formatSubmissionDate = (invoice) => {
    const date = new Date(invoice.SubmissionDate);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'submitted':
        return 'blue';
      case 'approved':
        return 'yellow';
      case 'rejected':
        return 'red';
      case 'recieved':
        return 'green';
      default:
        return 'gray';
    }
  };

  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      p={4}
      mb={4}
      shadow="md"
      bg="white"
    >
      <Flex justifyContent="space-between" alignItems="center" mb={2}>
        <Text fontSize="lg" fontWeight="bold">
          Invoice #{invoice.invoiceNo}
        </Text>
        <Badge colorScheme={getStatusColor(invoice.invoiceStatus)}>{invoice.invoiceStatus}</Badge>
      </Flex>

      <Text fontSize="md" color="gray.600" mb={2}>
        Job Title: {invoice.jobTitle}
      </Text>

      <Text fontSize="md" color="gray.600" mb={2}>
        Amount: {invoice.totalAmountToBePayable} {invoice.currencyType}
      </Text>

      <Text fontSize="md" color="gray.600" mb={2}>
        Date Issued: {new Date(invoice.SubmissionDate).toLocaleDateString()}
      </Text>

      {invoice.invoiceStatus === 'rejected' && invoice.rejectionReason && (
        <Text fontSize="md" color="red.500" mb={2}>
          Rejection Reason: {invoice.rejectionReason}
        </Text>
      )}

      <Flex justifyContent="flex-end">
        <Button colorScheme="blue" size="sm" mr={2} onClick={handleOpenModal}>
          View Details
        </Button>
        {/* <Button colorScheme="green" size="sm">
          Download
        </Button> */}
      </Flex>

      <Modal isOpen={isModalOpen} onClose={handleCloseModal} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <InvoiceDetails 
                {...invoice}
                jobId={invoice.jobId}
                applicantName={invoice.employeeName}
                applicantAddress={invoice.employeeAddress}
                applicantEmail={invoice.employeeEmail}
                providerName={invoice.employerName}
                salary={invoice.payrate}
                jobStartTime={invoice.jobStartTime}
                jobTitle={invoice.jobTitle}
                jobEndTime={invoice.jobEndTime}
                jobStartDate={formatJobStartDate(invoice)}
                jobEndDate={formatJobEndDate(invoice)}
                totalHours={invoice.totalWorkingHours}
                totalSalary={invoice.totalAmountToBePayable} 
                submissionDate={formatSubmissionDate(invoice)}
                invoiceNo={invoice.invoiceNo}
                status={invoice.invoiceStatus}
                isFromClockinModal={false}
                onClose={handleCloseModal}
                isApplicant = {true}
            />
          </ModalBody>
        </ModalContent>
      </Modal>      
    </Box>
  );
};

export default InvoiceCard; 